import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { MainContent } from './MainContent'
export const EmployeeAttendanceDetail=(props)=> {
  return (
    <>
    <MainDiv>
    <MainContent />
    </MainDiv>
    </>
    
  )
}
